/**
 * ENSD eta noise seed delta
 */

import { InputNumber, Tooltip } from 'antd'
import classNames from 'classnames'
import { MySlider } from '~/components/ui/MySlider'
import { QuestionCircleOutlined } from '@ant-design/icons'

import styles from './AiForm.module.css'

interface Props {
  ensd: number | undefined
  setEnsd: (a: number) => void
  disabled?: boolean
}

export function Ensd({ ensd, setEnsd, disabled = false }: Props) {
  return (
    <div className="flex items-center mb-3">
      <span className={classNames('text-neutral-500 w-[120px]')}>
        ENSD{' '}
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title="ENSD相同，可以让创作保持一致的eta值"
        >
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <MySlider
        className="flex-1"
        step={1}
        min={0}
        max={65535}
        value={ensd}
        onChange={val => {
          setEnsd(val)
        }}
        tooltip={{ formatter: null }}
        disabled={disabled}
      />
      <InputNumber
        min={0}
        max={65535}
        className={styles.inputNumber}
        value={ensd}
        onChange={val => {
          setEnsd(Math.floor(val!))
        }}
        disabled={disabled}
      />
    </div>
  )
}
